<template>
    <div class="card bg-transparent1">
        <div class="card-header border-bottom">
            <i class="fas fa-th me-2"></i>Dashboard
        </div>
        <div class="card-body p-3 bg-light">
            <div class="row">
                <div class="col-12 col-sm-6 mb-4">
                    <div class="card">
                        <div class="card-body">
                            <Apex :options="options" :series="series" />
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 mb-4">
                    <div class="card">
                        <div class="card-body">
                            <!-- <Apex :options="options1" :series="seriesPie" type="pie" height="285" /> -->
                            <Apex :options="options1" :series="series1" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-4 mb-4">
                    <SimpleCard
                        header="Leads By Region"
                        body="Lorem Ipsum dolor amet"
                        footer="This is footer"
                    >
                        <template #header>
                            <i class="fas fa-info-circle text-secondary me-2"></i>
                            Lorem ipsum dolor default text
                        </template>

                        <template #body>
                            <h2>Lorem Ipsum</h2>
                            <h5>"Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit..."</h5>
                            <hr class="my-2" />
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                                scelerisque risus ac turpis ultricies rutrum. Pellentesque eget
                                venenatis sem. Nunc facilisis justo justo, sit amet varius justo
                                hendrerit et. Nulla turpis lectus, faucibus ut pellentesque sed, mollis
                                mollis ante. Fusce molestie, lectus faucibus efficitur faucibus, quam
                                nunc tempus eros, nec porta nulla elit eget ipsum. Maecenas porttitor et
                                massa nec tincidunt. Duis auctor mauris in tellus varius pharetra.
                                Aliquam id interdum turpis, fermentum rutrum massa. In eget malesuada
                                lectus. Sed facilisis magna arcu, at pharetra tortor ultrices at.
                                Phasellus eleifend diam ligula, egestas vulputate nunc cursus ac. Etiam
                                at libero sed eros finibus suscipit. Phasellus egestas quam ut lorem
                                consectetur, eu cursus turpis dictum. In tristique bibendum convallis.
                            </p>
                        </template>
                        <template #footer>Lorem ipsum dolor</template>
                    </SimpleCard>
                </div>

                <div class="col-12 col-sm-3 mb-4">
                    <ImageCard
                        image="/assets/images/svg/completion-graph.svg"
                        :items="[
                            {
                                title: 'Add your personal information',
                                subtitle: 'Go Profile Edit',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-user-edit fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Verify your phone',
                                subtitle: 'Send Verification SMS',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-paper-plane fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Verify your Face ID',
                                subtitle: 'Upload Pictures',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-video fs-5',
                                iconColor: '255,200,100',
                            },
                            {
                                title: 'Give permissions for personal data',
                                subtitle: 'View Agreement',
                                linkClass: 'link-primary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover',
                                icon: 'fas fa-briefcase fs-5',
                                iconColor: '255,200,100',
                            },
                        ]"
                    />
                </div>

                <div class="col-12 col-sm-5 mb-4">
                    <GroupCard
                        header="Trials Leads By Role"
                        image="/assets/images/svg/completion-graph.svg"
                        :columns="['Role', 'Leads']"
                        :items="[
                            {
                                title: 'Finance',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                ],
                            },
                            {
                                title: 'Management',
                                images: [
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                ],
                            },
                            {
                                title: 'Human Resources',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                ],
                            },
                            {
                                title: 'Development',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                ],
                            },
                            {
                                title: 'Design',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                ],
                            },
                            {
                                title: 'R&D',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                ],
                            },
                            {
                                title: 'Reliability',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                ],
                            },
                            {
                                title: 'Social Media',
                                images: [
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                    '/assets/img/avatar/a2.png',
                                    '/assets/img/avatar/a1.png',
                                ],
                            },
                        ]"
                    />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    // import BlogPostCard from "@/components/card/BlogPostCard";
    // import ListAvatarCard from "@/components/card/ListAvatarCard";
    import ImageCard from "@/components/card/ImageCard";
    import GroupCard from "@/components/card/GroupCard";
    // import TimelineCard from "@/components/card/TimelineCard";
    import SimpleCard from "@/components/card/SimpleCard";

    import Apex from "@/components/chart/Apex";

    export default {
        name: "DashboardPage",
        title: "Dashboard",
        components: {
            // BlogPostCard,
            // ListAvatarCard,
            ImageCard,
            GroupCard,
            // TimelineCard,
            SimpleCard,

            Apex,
        },
        setup() {
            const options = {
                chart: {
                    id: "vuechart-example",
                    //   height: 350,
                    type: "line",
                    //   stacked: false,
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    width: [0, 2, 5],
                    curve: "smooth",
                },
                plotOptions: {
                    bar: {
                        columnWidth: "50%",
                    },
                },

                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: "light",
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100],
                    },
                },
                labels: [
                    "01/01/2003",
                    "02/01/2003",
                    "03/01/2003",
                    "04/01/2003",
                    "05/01/2003",
                    "06/01/2003",
                    "07/01/2003",
                    "08/01/2003",
                    "09/01/2003",
                    "10/01/2003",
                    "11/01/2003",
                ],
                markers: {
                    size: 0,
                },
                xaxis: {
                    type: "datetime",
                },
                yaxis: {
                    title: {
                        text: "Points",
                    },
                    min: 0,
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0) + " points";
                            }
                            return y;
                        },
                    },
                },
            };

            const series = [
                {
                    name: "TEAM A",
                    type: "column",
                    data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                },
                {
                    name: "TEAM B",
                    type: "area",
                    data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                },
                {
                    name: "TEAM C",
                    type: "line",
                    data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
                },
            ];

            const options1 = {
                chart: {
                    type: "bar",
                    height: 350,
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "55%",
                        endingShape: "rounded",
                    },
                },
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["transparent"],
                },
                xaxis: {
                    categories: [
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                    ],
                },
                yaxis: {
                    title: {
                        text: "$ (thousands)",
                    },
                },
                fill: {
                    opacity: 1,
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return "$ " + val + " thousands";
                        },
                    },
                },
            };

            const series1 = [
                {
                    name: "Net Profit",
                    data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
                },
                {
                    name: "Revenue",
                    data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
                },
                {
                    name: "Free Cash Flow",
                    data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
                },
            ];

            // const seriesPie = [44, 55, 13, 43, 22];

            return { options, series, options1, series1 };
        },
    };
</script>


<style lang="scss" scoped>
</style>